function CharacterLimit({ text = '', min = 0, max = 200 }) {
    return (
        <p className="text-end text-secondaryInput text-xs">
            <span className="font-semibold ">{text || 'character limit'}</span> : <span>{min + '/' + max}</span>
        </p>
    );
}

export default CharacterLimit;
